/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Component, Input } from '@angular/core';
import { Tour } from '@shared/models';

@Component({
    selector: 'app-tour-item-vao',
    templateUrl: './tour-item-vao.component.html',
    styleUrls: ['./tour-item-vao.component.scss'],
    standalone: false
})
export class TourItemVaoComponent {
  @Input() tour: Tour;

  get hasVao(): boolean {
    return this.tour.constructionSite.documents.filter(document => document.isVao).length > 0;
  }
}
